import React from 'react'
import styled from '@emotion/styled'

import { FlexDiv } from '../generic/Basics'
import { fontSizeMedium, fontSizeXLarge, grayLight40, fontSize2XSmall, blueBase, grayLight20 } from '../../constants/principles'
import Step1 from './steps/Step1'
import Step2 from './steps/Step2'
import Step3 from './steps/Step3'
import NumberChevron from './steps/ChevronDown'
import { breakpoints } from '../../constants'
import IneligibleSteps from './IneligibleSteps'
import IneligibleExplanation from './IneligibleExplanation'

const GetCash = __PATH_PREFIX__ + '/Landing/GetCashOrTradeInCredit.svg'

export default ({
  stepType,
  isDesktop,
  kbbUrl,
  atcUrl,
  year,
  make,
  model,
  trim,
  replacementVehicle,
  dealers,
  offerId,
  isCobrand,
  isAssigned,
  dealerName,
  updateGlobalState,
  appointments,
  isAppointmentRequestEnabled,
  addImpressions,
  reserveOffer,
  dealerIsDirectToKBB,
  dealerIsDirectToKBBv2
}) => {
  let steps = []

  if (!dealerIsDirectToKBB && !dealerIsDirectToKBBv2) {
    steps = [
      {
        number: 1,
        header: isAssigned || reserveOffer ? 'This Dealer is Ready to Buy Your Car' : 'These Dealers are Ready to Buy Your Car',
        subheader: isAssigned || reserveOffer ? 'This dealer may contact you about your offer.' : 'Dealers may contact you about your offer.'
      },
      { number: 2, header: 'Prepare For Your Visit', subheader: 'To save time at the dealer, have these handy:' },
      {
        number: 3,
        header: 'Visit the Dealer & Review the Offer',
        subheader: (isAssigned ? dealerName : 'The dealer you choose') + ' will inspect your vehicle using the same questions you used. If they update the Offer, you’ll get an email automatically.'
      },
      { number: 4, header: 'Redeem Your Offer', subheader: 'You get cash or trade-in credit. It’s your choice.' }
    ]
  } else {
    steps = [
      {
        number: 1,
        header: 'Your Dedicated Kelley Blue Book Specialist',
        subheader: dealerIsDirectToKBB ? `Set up an appointment or your Kelley Blue Book Specialist will contact you within one business day.` : `Set up an appointment or your Kelley Blue Book Specialist may contact you first.`
      },
      { number: 2, header: 'Prepare For Your Pick Up', subheader: 'Save time by having these handy:' }
    ]
  }

  return (
    <MainStepDiv stepTradeInCobrand={stepType === 'trade-in' && !isCobrand && !!isAssigned}>
      {(stepType === 'dealer' || (stepType === 'trade-in' && !isCobrand && !isAssigned)) && <HeaderText>Next Steps</HeaderText>}
      {stepType === 'dealer' &&
        steps.map(step => (
          <StepDiv id={`step-${step.number}`} data-testid={`oc-btn-step-${step.number}`} key={step.number} directToKBB={dealerIsDirectToKBB || dealerIsDirectToKBBv2}>
            {!dealerIsDirectToKBB && !dealerIsDirectToKBBv2 && (
              <NumberContainer>
                <ChevronDiv>
                  <NumberChevron color={blueBase} />
                </ChevronDiv>
                <NumberDiv>{step.number}</NumberDiv>
              </NumberContainer>
            )}
            <StepHeader>{step.header}</StepHeader>
            <Subheader>{step.subheader}</Subheader>
            {step.number === 1 ? (
              <Step1
                isCobrand={isCobrand}
                isDesktop={isDesktop}
                replacementVehicle={replacementVehicle}
                dealers={dealers}
                appointments={appointments}
                offerId={offerId}
                updateGlobalState={updateGlobalState}
                isAppointmentRequestEnabled={isAppointmentRequestEnabled}
                addImpressions={addImpressions}
                isAssigned={isAssigned}
                reserveOffer={reserveOffer}
                hideDealerAddress={dealerIsDirectToKBBv2}
              />
            ) : step.number === 2 ? (
              <Step2 dealerIsDirectToKBB={dealerIsDirectToKBB} dealerIsDirectToKBBv2={dealerIsDirectToKBBv2} />
            ) : step.number === 3 ? (
              <Step3 />
            ) : (
              <img alt="cash" src={GetCash} width="230" height="230" />
            )}
          </StepDiv>
        ))}
      {stepType === 'trade-in' && !isCobrand && !isAssigned && <IneligibleSteps {...{ year, make, model, trim, kbbUrl, atcUrl }} />}
      {stepType === 'trade-in' && !isCobrand && !!isAssigned && <IneligibleExplanation />}
    </MainStepDiv>
  )
}
const HeaderText = styled.div`
  font-size: ${fontSizeXLarge};
  font-weight: bold;
  padding: 8px 16px 0 16px;
  align-self: flex-start;
  text-align: center;
  @media (min-width: ${breakpoints.lg}px) {
    text-align: left;
  }
  width: 100%;
`

const StepDiv = styled(FlexDiv)`
  padding: ${p => (p.directToKBB ? 10 : 40)}px 0;
  text-align: center;
  width: 100%;
  :nth-of-type(odd) {
    background: ${grayLight40};
  }
  @media print {
    padding: 20px 0;
  }
`
const ChevronDiv = styled.div`
  z-index: 10;
`
const NumberDiv = styled.div`
  position: absolute;
  top: -2px;
  left: 15px;
  color: white;
  font-size: ${fontSizeXLarge};
  font-weight: bold;
`
const NumberContainer = styled.div`
  position: relative;
  width: 50px;
  height: 54px;
`

const MainStepDiv = styled(FlexDiv)`
  border-top: ${p => (p.stepTradeInCobrand ? '' : `4px solid ${grayLight20}`)};
  margin-top: 32px;
  width: 100%;
`

const StepHeader = styled.div`
  font-size: ${fontSizeMedium};
  font-weight: bold;
  padding-top: 32px;
  padding-bottom: ${p => (p.directToKBB ? '0px' : `6px`)};
  width: 100%;
`
const Subheader = styled.div`
  font-size: ${fontSize2XSmall};
  padding-bottom: ${p => (p.padding ? p.padding : `16px`)};
  width: 100%;
  max-width: 650px;
`
